import * as ApiManager from './_manager';
import store from '../store';

export const film = {
  create: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/create`,
      payload
    );
  },

  get: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/get`,
      payload
    );
  },

  list: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/list`,
      payload,
      payload && payload.isAutocomplete ? false :true
    );
  },

  delete: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/delete`,
      payload
    );
  },

  update: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/update`,
      payload
    );
  },

  embed: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/${payload.film_id}/embed`,
      payload
    );
  },

  requestRightHolderForMedia: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/requestRightHolderForMedia`,
      payload
    );
  },

  gDriveUpload: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/${payload.film_id}/upload/gDrive`,
      payload
    );
  },

  getSelectionList: payload => {
    return  ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/selectionList`,
      payload
    );
  },

  import: payload => {
    return  ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/import`,
      payload
    );
  },

  getStreamingUrl: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/film/${payload.film_id}/getStreamingUrl`,
      payload
    );
  },
};
